export default "__VITE_ASSET__Daa8wrHi__"